import {IVanillaReaderFontSetAsset, IVanillaReaderUiColorTheme} from "../VanillaReader/VanillaReaderModel";
import {MediaType} from "@colibrio/colibrio-reader-framework/colibrio-core-io-base";
import {EasyReadingPRO} from "../assets/fonts/EasyReadingPRO";

export class VanillaReaderAppAssets {
    static FontSets: IVanillaReaderFontSetAsset[] = [
        {
            name: 'SansSerif',
            defaults: {
                fallback: 'sans-serif',
            },
            fontFaces: [],
        },
        {
            name: 'Serif',
            defaults: {
                fallback: 'serif',
                serif: 'serif',
                sansSerif: 'serif',
                cursive: 'serif',
                monospace: 'serif',
                fantasy: 'serif',
            },
            fontFaces: [],
        },
        {
            name: 'EasyReading',
            defaults: {
                fallback: 'EasyReading',
            },
            fontFaces: [
                {
                    family: 'EasyReading',
                    mediaType: MediaType.FONT_TTF,
                    src: EasyReadingPRO,
                },
            ],
        },
        {
            name: 'Ysabeau Infant',
            defaults: {
                fallback: 'Ysabeau Infant',
            },
            fontFaces: [
                {
                    family: 'Ysabeau Infant',
                    mediaType: MediaType.FONT_TTF,
                    srcUrl: 'https://s3.eu-north-1.amazonaws.com/assets.demo.colibrio.com/fonts/YsabeauInfant-VariableFont_wght.ttf',
                    src: ''
                },
            ],
        },
    ];

    static ColorThemes: IVanillaReaderUiColorTheme[] = [
        {
            name: 'Default',
            backgroundLight: '#3e3e3e',
            backgroundDark: '#303030',
            foregroundLight: '#ffffff',
            foregroundDark: '#dedede',
            accent: '#36d677',

            uiIsDark: true,
            uiOutlineLight: 'rgba(255,255,255,0.5)',
            uiOutlineDark: 'rgba(255,255,255,0.2)',
            uiBackgroundLight: '#3e3e3e',
            uiBackgroundDark: '#303030',
            uiForegroundLight: '#ffffff',
            uiForegroundDark: '#dedede',
        },
        {
            name: 'Dark',
            backgroundLight: '#3e3e3e',
            backgroundDark: '#303030',
            foregroundLight: '#ffffff',
            foregroundDark: '#dedede',
            accent: '#36d677',

            uiIsDark: true,
            uiOutlineLight: 'rgba(255,255,255,0.5)',
            uiOutlineDark: 'rgba(255,255,255,0.2)',
            uiBackgroundLight: '#3e3e3e',
            uiBackgroundDark: '#303030',
            uiForegroundLight: '#ffffff',
            uiForegroundDark: '#dedede',

        },
        {
            name: 'ContrastDark',
            backgroundLight: '#000000',
            backgroundDark: '#000000',
            foregroundLight: '#ffffff',
            foregroundDark: '#ffffff',
            accent: '#ffde00',

            uiIsDark: true,
            uiOutlineLight: 'rgba(255, 255, 255, 1)',
            uiOutlineDark: 'rgba(255, 255, 255, 0.6)',
            uiBackgroundLight: '#000000',
            uiBackgroundDark: '#000000',
            uiForegroundLight: '#ffffff',
            uiForegroundDark: '#ffffff',

        },
        {
            name: 'Paperlike',
            backgroundLight: '#ece8e2',
            backgroundDark: '#b3a196',
            foregroundLight: '#ece8e2',
            foregroundDark: '#38251d',
            accent: '#D88C00',

            uiIsDark: false,
            uiOutlineLight: '#7f5e4d',
            uiOutlineDark: '#a7958c',
            uiBackgroundLight: '#ece8e2',
            uiBackgroundDark: '#b3a196',
            uiForegroundLight: '#ece8e2',
            uiForegroundDark: '#38251d',
        }
    ];
}
